import { UserInfo, ValidationColumn, TcbObjInfo, FpcModel, FpcParam, StepperItem, ClientQueryParamsView } from '../models/models';
import { fpcTypeEnum, CQStatusEnum, StepItemIndexEnum } from '../models/enums';
import { UploadFileInfo, UploadFileStatus } from '@progress/kendo-react-upload';
import moment from 'moment';
import {downloadFile} from '../utils/nativeBridge';

const FILE_UPLOAD_PARAM_CLASS_CODE = 'File Upload';


export class FpcLib {
    
    public BuildParamValsFromTcbObjs(tcbObjs: TcbObjInfo[], securityId? : number) {
        var plStr = "";
        var pliStr = "";
        var itmStr = "";
        var secStr = "";

        if (securityId){
            secStr=securityId.toString()
        }

        tcbObjs.forEach(x => {
            switch (x.tcbObjClass) {
                case "P":
                    plStr += x.tcbObjId.toString() + ",";
                    break;
                case "T":
                    pliStr += x.tcbObjGuidStr + ",";
                    break;
                case "I":
                    itmStr += x.tcbObjId.toString() + ",";
                    break;
            }
        });
        
        let fpcParams: FpcParam[] = [];
        if (plStr.length > 0) {
            fpcParams.push({ParameterName: "CqPackListIDs", ParameterValue: plStr.substring(0, plStr.length-1)});
        }
        if (pliStr.length > 0) {
            fpcParams.push({ParameterName: "CqPackListItemIDs", ParameterValue: pliStr.substring(0, pliStr.length-1)});
        }
        if (itmStr.length > 0) {
            fpcParams.push({ParameterName: "CqItemIds", ParameterValue: itmStr.substring(0, itmStr.length-1)});
        }
        if (secStr.length > 0){
            fpcParams.push({ParameterName: "CqSecurityId", ParameterValue: secStr});
        }


        return  JSON.stringify(fpcParams);
    }


    public InitialiseFpcModel(usr: UserInfo, cqGrpId?: number, cqId?: number, tcbObjs?: TcbObjInfo[]) {

    }

    public SetErrorMessage(fpc:FpcModel, errTitle: string, errMsg: string) {
        fpc.fpcStatus = CQStatusEnum.DisplayError;
        fpc.ErrorData.ErrorTitle = errTitle;
        var col = new ValidationColumn("Error Message", "ErrorMessage");
        fpc.ErrorData.Columns = [];
        fpc.ErrorData.Data = [];
        fpc.ErrorData.Columns.push(col);
        fpc.ErrorData.Data.push({ "ErrorMessage": errMsg })

        //Disable Stepper Items
        fpc.stepperItems.forEach(x => { x.disabled = true });
        fpc.showStepper = false;
        fpc.cqRunStartedOnUtcMs = 0;
        fpc.cqRunElapsedSeconds = 0;
        fpc.cqRunBaseLoadingStatusMsg = '';
        fpc.cqRunJobId = '';
    }

    public LoadStepperItems(fpc:FpcModel, onSuccess?: (para: FpcModel) => void, onError?: (para: FpcModel) => void) {
        let url = fpc.userInfo.currProject.apiUrl + '/api/Fpc/GetClientQuerySteps';
        let body = {
            clientQueryId: fpc.clientQueryId,
            enableSelect: fpc.canSelectQuery
        }

        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + fpc.userInfo.token } })
            .then(this.HandleErrors)
            .then(resp => resp.json())
            .then(res => {
                if (res.callStatus !== "OK") {
                    throw (res.callStatusMessage);
                } else {
                    fpc.stepperItems = res.results;
                    fpc.stepperCurrentIndex = this.setStartingStepperIndex(fpc.stepperItems);
                }
                if (onSuccess) onSuccess(fpc);
            })
            .catch(err => {
                this.SetErrorMessage(fpc, "Error Loading Steps", err.toString());
                if (onError) onError(fpc);
            });

    }

    public LoadClientQuery(fpc: FpcModel, onLoad?: (para: FpcModel) => void, onError?: (para: FpcModel) => void) {
        let url = fpc.userInfo.currProject.apiUrl + '/api/Fpc/GetClientQueryDetails';
        let body = {
            clientQueryId: fpc.clientQueryId,
            clientQueryParamValues: fpc.clientQueryParamValues,
        }
        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + fpc.userInfo.token }) })
            .then(this.HandleErrors)
            .then(resp => resp.json())
            .then(res => {
                if (res.callStatus !== "OK") {
                    this.SetErrorMessage(fpc, "Load Process failed", res.callStatusMessage);
                    if (onError) {
                        onError(fpc);
                    }
                }
                else {
                    fpc.cqSQL = res.result.clientQuerySQL;
                    fpc.cqValidationTypeId = res.result.validationTypeId;
                    fpc.cqValidationSQL = res.result.validationSQL;
                    fpc.cqHelpDescription = res.result.helpDescription;

                    fpc.clientQueryDesc = res.result.clientQueryDesc;
                    fpc.clientQueryParams = [];

                    res.result.clientQueryParams.forEach((e: ClientQueryParamsView) => {
                        if (e.parameterClassCode === "Yes or No" || e.parameterClassCode === "CQ - Yes or No") {
                            e.parameterValue = "0";
                        }

                        if (e.defaultValueSQL) {
                            e.defaultValueFetchInProg = false;
                            e.defaultValueFetched = false;
                        }

                        fpc.clientQueryParams.push(e)
                    });


                    switch (res.result.resultsType) {
                        case "ssrs_report":
                            fpc.fpcType = fpcTypeEnum.ReportViewer;
                            break;
                        case "imageviewer":
                            fpc.fpcType = fpcTypeEnum.ImageViewer;
                            break;
                        case "data_grid":
                        default:
                            fpc.fpcType = fpcTypeEnum.ClientQuery;
                            break;
                    }

                    if (onLoad) onLoad(fpc);

                }
            })
            .catch(err => {
                this.SetErrorMessage(fpc, "Error fetching Authenticate response", err.toString());
            });

    }

    // A "File Upload" param's value is a JSON-serialized list of UploadFileInfo. It is only
    // considered complete once every selected file has finished uploading successfully - a
    // non-empty value on its own (e.g. while files are queued/uploading/failed) is not enough.
    public IsFileUploadParamComplete = (param: ClientQueryParamsView): boolean => {
        if (!param.parameterValue)
            return false;

        try {
            let files: Array<UploadFileInfo> = JSON.parse(param.parameterValue);
            return files.length > 0 && files.every(f => f.status === UploadFileStatus.Uploaded);
        } catch {
            return false;
        }
    }

    public IsClientQueryParamSatisfied = (param: ClientQueryParamsView): boolean => {
        if (param.parameterClassCode === FILE_UPLOAD_PARAM_CLASS_CODE)
            return this.IsFileUploadParamComplete(param);

        return !!param.parameterValue;
    }

    public UpdateStepperStatusWithRequiredParamsStatus = (fpc: FpcModel) => {
        let reqParamsExist = fpc.clientQueryParams.some((x) => x.isRequired && !this.IsClientQueryParamSatisfied(x));

        // Even when not marked as required, a File Upload param with files still queued, uploading
        // or failed must block progression so the user cannot move on before uploads finish.
        let fileUploadsPending = fpc.clientQueryParams.some((x) => x.parameterClassCode === FILE_UPLOAD_PARAM_CLASS_CODE && x.parameterValue && !this.IsFileUploadParamComplete(x));

        let blockNextStep = reqParamsExist || fileUploadsPending;

        let validateStep = fpc.stepperItems.find(x => x.index === StepItemIndexEnum.Validate);
        if (validateStep) {
            if (!fpc.cqValidationSQL || blockNextStep)
                validateStep.disabled = true;
            else
                validateStep.disabled = false;
        }

        let resultsStep = fpc.stepperItems.find(x => x.index === StepItemIndexEnum.Results);
        if (resultsStep) {
            if (blockNextStep || fpc.cqValidationSQL)
                resultsStep.disabled = true;
            else
                resultsStep.disabled = false;
        }

    }

    public UpdateStepperStatusWithValidationStatus = (fpc: FpcModel) => {
        let resultsStep = fpc.stepperItems.find(x => x.index === StepItemIndexEnum.Results);
        if (resultsStep) {
            resultsStep.disabled = false;
        }
    }

    public RunCqValidation(fpc: FpcModel, callBackFunc: (para: FpcModel) => void) {

        let url = fpc.userInfo.currProject.apiUrl + '/api/Fpc/RunCqValidation';


        let body = {
            clientQueryId: fpc.clientQueryId,
            clientQueryParams: fpc.clientQueryParams
        }

        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + fpc.userInfo.token } })
            .then(this.HandleErrors)
            .then(resp => resp.json())
            .then(res => {
                if (process.env.REACT_APP_RunMode === "TST") {
                    console.log('Validation SQL;')
                    console.log(res.result.debugSQL);
                }

                if (res.callStatus !== "OK") {
                    this.SetErrorMessage(fpc, "Validation failed", res.callStatusMessage);
                }
                else {
                    fpc.ValidationInfo.ActionCode = res.result.actionCode;
                    fpc.ValidationInfo.Columns = res.result.columns.map((x: ValidationColumn) => ({ ...x }));
                    fpc.ValidationInfo.Columns.forEach((c) => { c.minWidth = c.width });
                    fpc.ValidationInfo.Data = JSON.parse(res.result.data);
                    switch (fpc.ValidationInfo.ActionCode.toLowerCase()) {
                        case "run":
                            fpc.fpcStatus = CQStatusEnum.RunCq;
                            break;
                        case "confirm":
                        case "validate":
                        case "validate_dirtyonly":
                        case "validate_all":
                            fpc.fpcStatus = CQStatusEnum.DisplayConfirmResults;
                            fpc.ValidationInfo.DataKeyName = fpc.ValidationInfo.Columns[0].fieldName;
                            this.UpdateStepperStatusWithValidationStatus(fpc);
                            break;
                        case "confirm_with_multiple_column_selection":
                        case "confirm_with_multiple_selection":
                        case "confirm_with_single_selection":
                        case "validatemultiselect":
                        case "validatemultiselect_all":
                        case "validatemultiselect_dirtyonly":
                        case "validatesingleselect":
                        case "validatesingleselect_all":
                        case "validatesingleselect_dirtyonly":
                            fpc.fpcStatus = CQStatusEnum.DisplayConfirmResults;
                            fpc.ValidationInfo.DataKeyName = fpc.ValidationInfo.Columns[0].fieldName;

                            //Add Selected property to validation columns
                            let valCol: ValidationColumn = new ValidationColumn("selected", "selected");
                            valCol["dataType"] = "select";
                            valCol["width"] = 50;
                            fpc.ValidationInfo.Columns.unshift(valCol);

                            //Add Selected property to data 
                            fpc.ValidationInfo.Data.forEach(x => x.selected = false);

                            this.UpdateStepperStatusWithValidationStatus(fpc);
                            break;
                        case "fail":
                            fpc.fpcStatus = CQStatusEnum.DisplayError;
                            fpc.ErrorData.ErrorTitle = "Validation failed";
                            fpc.ErrorData.Columns = fpc.ValidationInfo.Columns;
                            fpc.ErrorData.Data = fpc.ValidationInfo.Data;
                            break;
                        default:
                            this.SetErrorMessage(fpc, "Invalid Action Code", "Action code of \"" + fpc.ValidationInfo.ActionCode + "\" is not valid");
                    }
                }
            })
            .catch(err => {
                this.SetErrorMessage(fpc, "Error running CQ Validation", err.toString());
            })
            .finally(() => { callBackFunc(fpc); });
    }

    public RunCq(fpc: FpcModel, callBackFunc: (para: FpcModel) => void, onProgress?: (para: FpcModel) => void) {
        const baseLoadingStatusMsg = fpc.loadingStatusMsg && fpc.loadingStatusMsg.trim().length > 0
            ? fpc.loadingStatusMsg
            : "Running Process...";

        fpc.cqRunBaseLoadingStatusMsg = baseLoadingStatusMsg;
        fpc.cqRunStartedOnUtcMs = Date.now();
        fpc.cqRunElapsedSeconds = 0;

        const updateProgress = (elapsedSeconds: number) => {
            fpc.cqRunElapsedSeconds = elapsedSeconds;
            fpc.loadingStatusMsg = this.buildPollingLoadingMessage(baseLoadingStatusMsg, elapsedSeconds);
            if (onProgress) {
                onProgress(fpc);
            }
        };

        updateProgress(0);

        let body = {
            clientQueryId: fpc.clientQueryId,
            clientQueryParams: fpc.clientQueryParams,
            validationData: ''
        }

        if (fpc.ValidationInfo.ActionCode.toLowerCase() === "validate_all" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "validatesingleselect_all" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "validatemultiselect_all" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "confirm" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "confirm_with_multiple_column_selection" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "confirm_with_multiple_selection" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "confirm_with_single_selection"
        ) {

            body.validationData = JSON.stringify(fpc.ValidationInfo.Data)
        }

        if (fpc.ValidationInfo.ActionCode.toLowerCase() === "validate" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "validatesingleselect" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "validatemultiselect" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "validate_dirtyonly" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "validatesingleselect_dirtyonly" ||
            fpc.ValidationInfo.ActionCode.toLowerCase() === "validatemultiselect_dirtyonly") {

            body.validationData = JSON.stringify(fpc.ValidationInfo.Data.filter(x => x.dirty))
        }

        const runAsync = async () => {
            try {
                const startUrl = fpc.userInfo.currProject.apiUrl + '/api/Fpc/RunCqAsync';
                const startResp = await fetch(startUrl, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + fpc.userInfo.token } });
                this.HandleErrors(startResp);
                const startRes = await startResp.json();

                if (startRes.callStatus !== "OK") {
                    this.SetErrorMessage(fpc, "Process failed", startRes.callStatusMessage);
                    return;
                }

                const jobId = this.extractJobId(startRes.result ?? startRes.Result);
                if (!jobId) {
                    this.SetErrorMessage(fpc, "Process failed", "Unable to start background process job");
                    return;
                }

                fpc.cqRunJobId = jobId;
                if (onProgress) {
                    onProgress(fpc);
                }

                const completedResult = await this.pollRunCqJob(fpc, jobId, updateProgress);
                const runResult = this.getCompletedRunCqResult(completedResult);
                await this.applyRunCqResult(fpc, runResult);
            }
            catch (err) {
                this.SetErrorMessage(fpc, "Error fetching Run CQ data", err?.toString() ?? "Unknown error");
            }
            finally {
                callBackFunc(fpc);
            }
        };

        runAsync();
    }

    private async applyRunCqResult(fpc: FpcModel, result: any) {
        // Handle file download results
        if (result.actionCode && result.actionCode.toUpperCase() === 'FILE') {
            try {
                // Fetch file from the GetCqResultFile endpoint
                const fileUrl = fpc.userInfo.currProject.apiUrl + '/api/Fpc/GetCqResultFile?jobId=' + encodeURIComponent(fpc.cqRunJobId);
                const fileResp = await fetch(fileUrl, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + fpc.userInfo.token }
                });

                this.HandleErrors(fileResp);

                if (!fileResp.ok) {
                    throw new Error(`Failed to download file: ${fileResp.statusText}`);
                }

                // Extract filename from Content-Disposition header
                const fileName = this.extractFileNameFromResponse(fileResp);

                // Get the blob from the response
                const blob = await fileResp.blob();

                // Trigger the file download
                this.triggerFileDownload(blob, fileName);
                
                fpc.fpcStatus = CQStatusEnum.DisplayCqResults;
                fpc.ResultData.ActionCode = 'success';
                fpc.ResultData.Columns = [];
                fpc.ResultData.Data = [{
                    message: 'File download completed successfully'
                }];
            } catch (err) {
                this.SetErrorMessage(fpc, "Error downloading result file", err instanceof Error ? err.message : err?.toString() ?? "Unknown error");
            }
            finally {
                fpc.cqRunStartedOnUtcMs = 0;
                fpc.cqRunElapsedSeconds = 0;
                fpc.cqRunBaseLoadingStatusMsg = '';
                fpc.cqRunJobId = '';
            }
            return;
        }

        fpc.ResultData.ActionCode = result.actionCode;
        fpc.ResultData.Columns = result.columns.map((x: ValidationColumn) => ({ ...x }));
        fpc.ResultData.Columns.forEach((c) => { c.minWidth = c.width });
        if (result.clientQueryResultId) {
            fpc.ResultData.ClientQueryResultId = result.clientQueryResultId;
            fpc.ResultData.ClientQueryResultRowCount = result.clientQueryResultRowCount;
            fpc.resultJsonStr = '';
        }
        else {
            fpc.ResultData.ClientQueryResultId = '';
            fpc.resultJsonStr = result.data;
            this.ConvertFetchedData(fpc);
        }

        switch (fpc.ResultData.ActionCode.toLowerCase()) {
            case "success":
            default:
                fpc.fpcStatus = CQStatusEnum.DisplayCqResults;
                break;
            case "grid":
            case "gridfixed":
            case "gridfull":
            case "gridauto":
                fpc.fpcStatus = CQStatusEnum.DisplayCqResultsGrid;
                break;
            case "fail":
                fpc.fpcStatus = CQStatusEnum.DisplayError;
                fpc.ErrorData.ErrorTitle = "Error running process";
                fpc.ErrorData.Columns = fpc.ResultData.Columns;
                fpc.ErrorData.Data = fpc.ResultData.Data;
                break;
        }

            fpc.cqRunStartedOnUtcMs = 0;
            fpc.cqRunElapsedSeconds = 0;
            fpc.cqRunBaseLoadingStatusMsg = '';
            fpc.cqRunJobId = '';
    }

    public ResumeRunCqPolling(fpc: FpcModel, callBackFunc: (para: FpcModel) => void, onProgress?: (para: FpcModel) => void) {
        if (!fpc.cqRunJobId) {
            callBackFunc(fpc);
            return;
        }

        const baseLoadingStatusMsg = fpc.cqRunBaseLoadingStatusMsg && fpc.cqRunBaseLoadingStatusMsg.trim().length > 0
            ? fpc.cqRunBaseLoadingStatusMsg
            : (fpc.clientQueryDesc && fpc.clientQueryDesc.trim().length > 0 ? fpc.clientQueryDesc + "..." : "Running Process...");

        const updateProgress = (elapsedSeconds: number) => {
            fpc.cqRunElapsedSeconds = elapsedSeconds;
            fpc.loadingStatusMsg = this.buildPollingLoadingMessage(baseLoadingStatusMsg, elapsedSeconds);
            if (onProgress) {
                onProgress(fpc);
            }
        };

        const runAsync = async () => {
            try {
                const completedResult = await this.pollRunCqJob(fpc, fpc.cqRunJobId, updateProgress);
                const runResult = this.getCompletedRunCqResult(completedResult);
                await this.applyRunCqResult(fpc, runResult);
            }
            catch (err) {
                this.SetErrorMessage(fpc, "Error fetching Run CQ data", err?.toString() ?? "Unknown error");
            }
            finally {
                callBackFunc(fpc);
            }
        };

        runAsync();
    }

    private extractJobId(jobData: any): string {
        if (!jobData) {
            return '';
        }

        return jobData.jobId ?? jobData.JobId ?? '';
    }

    private getJobStatus(jobData: any): string {
        if (!jobData) {
            return '';
        }

        return (jobData.status ?? jobData.Status ?? '').toString().toLowerCase();
    }

    private getJobError(jobData: any): string {
        if (!jobData) {
            return '';
        }

        return jobData.errorMessage ?? jobData.ErrorMessage ?? 'The background process failed';
    }

    private getJobResult(jobData: any): any {
        if (!jobData) {
            return null;
        }

        return jobData.result ?? jobData.Result;
    }

    private extractFileNameFromResponse(response: Response): string {
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=(?:(['"]).*?\1|[^;\n]*)/);
            if (fileNameMatch && fileNameMatch[0]) {
                let fileName = fileNameMatch[0].split('=')[1].trim().replace(/["']/g, '');
                // Handle URL-encoded filenames
                try {
                    fileName = decodeURIComponent(fileName);
                } catch (e) {
                    // If decoding fails, use the name as-is
                }
                return fileName;
            }
        }
        return 'download';
    }

    private triggerFileDownload(blob: Blob, fileName: string): void {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    private downloadFileFromBase64(base64Data: string, fileName: string): void {
        try {
            let cleanBase64 = base64Data;
            
            // Remove data URL prefix if present (e.g., "data:application/zip;base64,")
            if (cleanBase64.includes(',')) {
                cleanBase64 = cleanBase64.split(',')[1];
            }
            
            // Remove all whitespace
            cleanBase64 = cleanBase64.replace(/\s/g, '');
            
            // Decode base64 string to binary data
            const binaryString = atob(cleanBase64);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            
            // Convert binary string to bytes
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i) & 0xFF; // Ensure 0-255 range
            }
            
            // Determine MIME type based on file extension
            const mimeType = this.getMimeTypeFromFileName(fileName);
            
            // Create blob directly from Uint8Array
            const blob = new Blob([bytes], { type: mimeType });
            this.triggerFileDownload(blob, fileName);
        } catch (err) {
            console.error('Error downloading file from base64:', err);
        }
    }

    private downloadFileFromByteArray(fileData: any, fileName: string): void {
        try {
            let bytes: Uint8Array;
            
            // Handle different formats of fileData
            if (fileData instanceof Uint8Array) {
                bytes = fileData;
            } else if (Array.isArray(fileData)) {
                // fileData is an array of numbers
                bytes = new Uint8Array(fileData);
            } else if (typeof fileData === 'string') {
                // fileData is a base64 string
                const binaryString = atob(fileData);
                const len = binaryString.length;
                bytes = new Uint8Array(len);
                for (let i = 0; i < len; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
            } else {
                console.error('Unsupported fileData format');
                return;
            }
            
            // Determine MIME type based on file extension
            const mimeType = this.getMimeTypeFromFileName(fileName);
            
            // Create blob and trigger download
            // Create a new Uint8Array to ensure it uses ArrayBuffer (not SharedArrayBuffer)
            const blobData = new Uint8Array(bytes);
            const blob = new Blob([blobData], { type: mimeType });
            this.triggerFileDownload(blob, fileName);
        } catch (err) {
            console.error('Error downloading file from byte array:', err);
        }
    }

    private getMimeTypeFromFileName(fileName: string): string {
        const ext = fileName.toLowerCase().split('.').pop() || '';
        const mimeTypes: { [key: string]: string } = {
            'zip': 'application/zip',
            'pdf': 'application/pdf',
            'txt': 'text/plain',
            'csv': 'text/csv',
            'xls': 'application/vnd.ms-excel',
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'doc': 'application/msword',
            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'json': 'application/json',
            'xml': 'application/xml'
        };
        return mimeTypes[ext] || 'application/octet-stream';
    }

    private async pollRunCqJob(fpc: FpcModel, jobId: string, onProgress?: (elapsedSeconds: number) => void): Promise<any> {
        const pollDelayMs = 2000;
        const maxPollCount = 300;
        const statusUrl = fpc.userInfo.currProject.apiUrl + '/api/Fpc/GetCqJobStatus?jobId=' + encodeURIComponent(jobId);
        const startedOnMs = fpc.cqRunStartedOnUtcMs > 0 ? fpc.cqRunStartedOnUtcMs : Date.now();
        if (fpc.cqRunStartedOnUtcMs <= 0) {
            fpc.cqRunStartedOnUtcMs = startedOnMs;
        }

        for (let pollCount = 0; pollCount < maxPollCount; pollCount++) {
            const statusResp = await fetch(statusUrl, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + fpc.userInfo.token } });
            this.HandleErrors(statusResp);

            const statusRes = await statusResp.json();

            if (statusRes.callStatus !== 'OK') {
                throw new Error(statusRes.callStatusMessage || 'Failed to fetch job status');
            }

            const jobData = statusRes.result ?? statusRes.Result;
            const status = this.getJobStatus(jobData);
            if (onProgress && status === 'running') {
                onProgress(Math.floor((Date.now() - startedOnMs) / 1000));
            }

            if (status === 'completed') {
                return this.getJobResult(jobData);
            }

            if (status === 'failed') {
                throw new Error(this.getJobError(jobData));
            }

            await this.delay(pollDelayMs);
        }

        fpc.cqRunStartedOnUtcMs = 0;
        fpc.cqRunElapsedSeconds = 0;
        fpc.cqRunBaseLoadingStatusMsg = '';
        fpc.cqRunJobId = '';
        throw new Error('Background process timed out while waiting for completion');
    }

    private getCompletedRunCqResult(jobResult: any): any {
        if (!jobResult) {
            throw new Error('Background process completed with no result');
        }

        // Handle file download results (returned directly from pollRunCqJob)
        if (jobResult.actionCode === 'file_download' || jobResult.isFileDownload) {
            return jobResult;
        }

        if (jobResult.callStatus) {
            if (jobResult.callStatus !== 'OK') {
                throw new Error(jobResult.callStatusMessage || 'Process failed');
            }

            return jobResult.result ?? jobResult.Result;
        }

        if (jobResult.result && (jobResult.result.actionCode || jobResult.result.ActionCode)) {
            return jobResult.result;
        }

        if (jobResult.actionCode || jobResult.ActionCode) {
            return jobResult;
        }

        throw new Error('Background process returned an unexpected result payload');
    }

    private delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private buildPollingLoadingMessage(baseMessage: string, elapsedSeconds: number): string {
        return baseMessage + ' (Running - ' + elapsedSeconds.toString() + 's elapsed)';
    }

    FetchCqData(fpc: FpcModel, rowNum: number, onSuccess: (r: FpcModel) => void, onFailure: (e: string) => void) {
        let url = fpc.userInfo.currProject.apiUrl + '/api/Fpc/GetClientQueryResultRow';

        let body = {
            clientQueryResultId: fpc.ResultData.ClientQueryResultId,
            rowNumber: rowNum
        }

        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + fpc.userInfo.token } })
            .then(this.HandleErrors)
            .then(resp => resp.json())
            .then(res => {
                if (res.callStatus !== "OK") {
                    onFailure(res.callStatusMessage);
                    this.SetErrorMessage(fpc, "Fetching Results failed", res.callStatusMessage);
                } else {
                    fpc.resultJsonStr += res.stringResponse;
                    onSuccess(fpc);
                }
            });

    }

    ConvertFetchedData(fpc: FpcModel) {
        fpc.ResultData.Data = JSON.parse(fpc.resultJsonStr);
        // Replace JSON dates with real dates (for Excel export)
        fpc.ResultData.Columns.filter((c) => c.dataType.toLowerCase() === "date" || c.dataType.toLowerCase() === "datetime").forEach((e) => {
            const isDateTime = e.dataType.toLowerCase() === "datetime";
            
            fpc.ResultData.Data.filter((d) => d[e.fieldName]).forEach((d) => {
                let tmp: moment.Moment;
                
                // Try custom format code first if provided
                if (e.formatCode) {
                    tmp = moment(d[e.fieldName], e.formatCode);
                    if (tmp.isValid()) {
                        d[e.fieldName] = tmp.toDate();
                        return;
                    }
                }
                
                // Try ISO format first (works for both date and datetime)
                tmp = moment(d[e.fieldName], moment.ISO_8601);
                if (tmp.isValid()) {
                    d[e.fieldName] = tmp.toDate();
                    return;
                }
                
                // For datetime fields, try datetime formats with time components (non-US formats first)
                if (isDateTime) {
                    const dateTimeFormats = [
                        "DD/MM/YYYY HH:mm:ss",
                        "DD-MM-YYYY HH:mm:ss",
                        "DD/MM/YYYY HH:mm",
                        "DD-MM-YYYY HH:mm",
                        "YYYY-MM-DD HH:mm:ss",  // US format last
                        "YYYY-MM-DD HH:mm"      // US format last
                    ];
                    
                    for (const format of dateTimeFormats) {
                        tmp = moment(d[e.fieldName], format);
                        if (tmp.isValid()) {
                            d[e.fieldName] = tmp.toDate();
                            return;
                        }
                    }
                }
                
                // For date-only fields, try date formats without time (non-US formats first)
                if (!isDateTime) {
                    const dateFormats = [
                        "DD/MM/YYYY",
                        "DD-MM-YYYY"
                    ];
                    
                    for (const format of dateFormats) {
                        tmp = moment(d[e.fieldName], format);
                        if (tmp.isValid()) {
                            d[e.fieldName] = tmp.toDate();
                            return;
                        }
                    }
                }
                
                // If all else fails
                d[e.fieldName] = "Invalid Date";
            });
        });

    }

    RunCqSSRS(fpc: FpcModel, callBackFunc: (para: FpcModel) => void) {

        let url = fpc.userInfo.currProject.apiUrl + '/api/Fpc/RunCqSSRS';

        //Search for "OutputFormat" parameter in orig params, otherwise default to PDF
        let outFmt = "pdf";
        let of = fpc.clientQueryParams.find(x => x.parameterClassCode.toLowerCase() === "outputformat");
        if (of && of.defaultValueSQL) {
            outFmt = of.defaultValueSQL.toLowerCase();
        }


        let body = {
            outputFormat:  outFmt,
            clientQueryParams: fpc.ResultData.Data
        }

        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + fpc.userInfo.token } })
            .then(async resp => {
                if (!resp.ok) {
                    const errorBody = await resp.json().catch(() => null);
                    throw new Error(errorBody?.callStatusMessage || resp.statusText);
                }
                return resp;
            })
            .then(resp => resp.json())
            .then(res => {
                if (res.callStatus !== "OK") {
                    this.SetErrorMessage(fpc, "Error generating SSRS report", res.callStatusMessage);
                } else {

                    fpc.fpcStatus = CQStatusEnum.ReportGen;

                    var gg = atob(res.result.fileBody);
                    var len = gg.length;
                    var bytes = new Uint8Array(len);
                    for (var i = 0; i < len; i++) {
                        bytes[i] = gg.charCodeAt(i);
                    }

                    var file: Blob = new Blob();
                    if (!res.result.fileType) {
                        fpc.fpcStatus = CQStatusEnum.DisplayError;
                        fpc.errorTitle = "Report Type undefined";
                        fpc.errorMessage = "Report file type is not defined";
                    } else {

                        switch (res.result.fileType.toUpperCase()) {
                            case "DOC":
                            case "DOCX":
                                file = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                                break;
                            case "XLS":
                            case "XLSX":
                                // file = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                file = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                break;
                            case "PPTX":
                                file = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
                                break;
                            case "PDF":
                                file = new Blob([bytes], { type: 'application/pdf' });
                                break;
                            case "TIF":
                            case "TIFF":
                                file = new Blob([bytes], { type: 'image/tiff' });
                                break;
                            case "MHTML":
                                file = new Blob([bytes], { type: 'text/html' });
                                break;
                            case "CSV":
                                file = new Blob([bytes], { type: 'text/csv' });
                                break;
                            case "XML":
                                file = new Blob([bytes], { type: 'text/xml' });
                                break;
                            default:
                                fpc.fpcStatus = CQStatusEnum.DisplayError;
                                fpc.errorTitle = "Unsupported Report Output Type";
                                fpc.errorMessage = res.result.fileType + " is not a supported type";
                        }
                    }

                    if (fpc.fpcStatus !== CQStatusEnum.DisplayError) {

    console.log('[FPC-MODULE] File download triggered');
    console.log('[FPC-MODULE] File size:', file?.size);
    console.log('[FPC-MODULE] File name:', res.result.fileName);
    
    try {
        // Try native download first
        if (typeof downloadFile === 'function') {
            console.log('[FPC-MODULE] Attempting native download...');
            const mimeType = file.type || 'application/pdf';
            downloadFile(file, res.result.fileName, mimeType)
                .then(() => console.log('[FPC-MODULE] Native download completed'))
                .catch((error) => {
                    console.warn('[FPC-MODULE] Native download failed, using browser fallback');
                    console.warn('[FPC-MODULE] Error:', error);
                    
                    // Fallback to browser download
                    var fileURL = URL.createObjectURL(file);
                    var link = document.createElement('a');
                    link.href = fileURL;
                    link.download = res.result.fileName;
                    link.click();
                });
        } else {
            throw new Error('downloadFile not available');
        }
    } catch (error) {
        console.warn('[FPC-MODULE] Error checking downloadFile, using browser fallback');
        console.warn('[FPC-MODULE] Error:', error);
        
        // Fallback to browser download
        var fileURL = URL.createObjectURL(file);
        var link = document.createElement('a');
        link.href = fileURL;
        link.download = res.result.fileName;
        link.click();
    }
    
    fpc.fpcStatus = CQStatusEnum.ReportGen;


                    }
                }
            })
            .catch(err => {
                this.SetErrorMessage(fpc, "Error fetching SSRS data", err.toString());
            })
            .finally(() => { callBackFunc(fpc); });
    }

    RemoveCqResultData(fpc: FpcModel, callBack?: (e: FpcModel) => void) {

        if (!fpc.ResultData.ClientQueryResultId) {
            if (callBack) callBack(fpc);
            return;
        }

        let url = fpc.userInfo.currProject.apiUrl + '/api/Fpc/RemoveCqResultData';
        let body = {
            clientQueryResultId: fpc.ResultData.ClientQueryResultId
        }

        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + fpc.userInfo.token } })
            .then(this.HandleErrors)
            .then(resp => resp.json())
            .then(res => {
                if (res.callStatus !== "OK") {
                    alert("Error removing CQ result data"); //using alert at moment because prefer to see results than error
                }
            })
            .catch(err => {
                alert("Error removing CQ result data");
            })
            .finally(() => {if (callBack) callBack(fpc)});
    }


    RestartCq(fpc: FpcModel) {
        if (fpc.canSelectQuery) {
            fpc.fpcStatus = CQStatusEnum.SelectCQ;
        } else {
            if (this.HasParams(fpc))
                fpc.fpcStatus = CQStatusEnum.DisplayParams;
        }
    }

    IsItemEnabled = (fpc: FpcModel, idx: Number) => {
        let itm = fpc.stepperItems.find(x => x.index === idx);
        if (itm)
            return !itm.disabled;
        else
            return false;
    }

    public SetCurrentStepperItem(fpc: FpcModel, currIdx: number) {
        // this.updateStepperStatusWithRequiredParamsStatus();

        fpc.stepperCurrentIndex = currIdx;
        fpc.stepperItems.forEach((x) => { x.current = false });
        let itm = fpc.stepperItems.find(x => x.index === currIdx);
        if (itm) {
            itm.current = true;
        }

        fpc.stepperEnableBackButton = false;
        fpc.stepperEnableNextButton = false;

        switch (fpc.stepperCurrentIndex) {
            case StepItemIndexEnum.Select:
                if (fpc.clientQueryId !== 0)
                    fpc.stepperEnableNextButton = true;
                break;
            case StepItemIndexEnum.Parameters:
                if (this.isItemEnabled(fpc, StepItemIndexEnum.Select))
                    fpc.stepperEnableBackButton = true;

                if (this.isItemEnabled(fpc, StepItemIndexEnum.Validate) || this.isItemEnabled(fpc, StepItemIndexEnum.Results))
                    fpc.stepperEnableNextButton = true;
                break;
            case StepItemIndexEnum.Validate:
                if (this.isItemEnabled(fpc, StepItemIndexEnum.Select) || this.isItemEnabled(fpc, StepItemIndexEnum.Parameters))
                    fpc.stepperEnableBackButton = true;

                if (this.isItemEnabled(fpc, StepItemIndexEnum.Results))
                    fpc.stepperEnableNextButton = true;
                break;

            case StepItemIndexEnum.Results:
                if (this.isItemEnabled(fpc, StepItemIndexEnum.Select) || this.isItemEnabled(fpc, StepItemIndexEnum.Parameters) || this.isItemEnabled(fpc, StepItemIndexEnum.Validate))
                    fpc.stepperEnableBackButton = true;
                break;

        }

    }

    private isItemEnabled = (fpc: FpcModel, idx: Number) => {
        let itm = fpc.stepperItems.find(x => x.index === idx);
        if (itm)
            return !itm.disabled;
        else
            return false;
    }

    public HasParams(fpc: FpcModel): boolean {
        return fpc.clientQueryParams.some((x) => x.isVisible)
    }

    public HandleErrors(response: any) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    }

    private setStartingStepperIndex(itms: StepperItem[]): number {
        let retVal = 0;

        let tmp = itms.find(x => !x.disabled);
        if (tmp)
            retVal = tmp.index;

        return retVal;
    }


}


